import { render, staticRenderFns } from "./PersonalResourceComponent.vue?vue&type=template&id=4df52308&scoped=true"
import script from "./PersonalResourceComponent.vue?vue&type=script&lang=js"
export * from "./PersonalResourceComponent.vue?vue&type=script&lang=js"
import style0 from "./PersonalResourceComponent.vue?vue&type=style&index=0&id=4df52308&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df52308",
  null
  
)

export default component.exports